// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__p-V5m","mainContent":"App_mainContent__mD5IX"};